import { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setInternalTransition } from '../redux/actions/app/history';
import { addPathToHistoryPathList } from '../services/historyPathList';

export const useRouteTransition = () => {
  const isInitialRender = useRef(true);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isInitialRender.current) {
      dispatch(setInternalTransition());
    }
    addPathToHistoryPathList(location?.pathname);

    isInitialRender.current = false;
  }, [dispatch, location]);
};
